/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
// import { connect } from 'react-redux'
// import { withFormik } from 'formik'
// import Yup from 'yup'

/**
 *     Import
 *     - Components
 */
import { Button } from '../../../../common/Button/Button'

export default class Other extends React.Component<any, any> {

    private otherDescription

    constructor(props: any) {
        super(props)
        this.state = {
            dirty: false,
            value: '',
        }
    }

    handleChange = (e: any) => {
        this.setState({
            dirty : true,
            value: e.target.value,
        })
    }

    handleSubmit = () => {
        this.setState({ dirty: false })
        this.props.updateData(this.otherDescription.value)
    }

    render() {

        const placeholder =
        `For changes other than sums insured or location details, please tell us what you would like to amend.`

        return(
            <div className="mta__other quote__form">
                <h3>Other Mid Term Adjustment</h3>
                <textarea
                    placeholder={placeholder}
                    onChange={this.handleChange}
                    value={this.state.value}
                    id="otherDescription"
                    ref={(input) => { this.otherDescription = input }}
                />

                <Button
                    className={`btn btn--submit ${!this.state.dirty ? 'btn--hide' : null}`}
                    submit={false}
                    onClick={this.handleSubmit}
                >
                    Update
                </Button>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Policies/MTA/components/Other.tsx